import { gql } from '@apollo/client';

export class AdminGQLFunction {
  static GET_ALL_ADMINS = gql`
    query allAdmins($page: Int!, $rowsPerPage: Int!) {
      allAdmins(page: $page, rowsPerPage: $rowsPerPage) {
        len
        admins {
          id
          username
          email
          telephone
          password
          userState
        }
      }
    }
  `;

  static GET_SEARCH_ADMINS = gql`
    query searchAdmins($page: Int!, $rowsPerPage: Int!, $searchField: String!, $searchStr: String!) {
      searchAdmins(page: $page, rowsPerPage: $rowsPerPage, searchField: $searchField, searchStr: $searchStr) {
        len
        admins {
          id
          username
          email
          telephone
          password
          userState
        }
      }
    }
  `;

  static GET_ADMIN_INFO = gql`
    query adminInfo($id: String!) {
      adminInfo(id: $id) {
        id
        username
        email
        telephone
        password
        userState
      }
    }
  `;

  static CREATE_ADMIN = gql`
    mutation createNewAdmin($email: String!, $password: String!, $username: String!, $telephone: String!) {
      createNewAdmin(email: $email, password: $password, username: $username, telephone: $telephone) {
        id
        err
        msg
      }
    }
  `;

  static UPDATE_ADMIN = gql`
    mutation updateAdmin(
      $id: String!
      $email: String!
      $password: String!
      $username: String!
      $telephone: String!
      $userState: Int!
    ) {
      updateAdmin(
        id: $id
        email: $email
        password: $password
        username: $username
        telephone: $telephone
        userState: $userState
      ) {
        admin {
          id
          username
          email
          userState
          telephone
        }
        err
        msg
      }
    }
  `;

  static UPDATE_ADMIN_STATE = gql`
    mutation updateAdminState($id: String!) {
      updateAdminState(id: $id) {
        admin {
          id
          username
          email
          userState
          telephone
        }
        err
        msg
      }
    }
  `;

  static DELETE_ADMIN = gql`
    mutation removeAdmin($id: String!) {
      removeAdmin(id: $id) {
        admin {
          id
          username
          email
          userState
          telephone
        }
        err
        msg
      }
    }
  `;
}
